import React from 'react';
import classNames from 'classnames';
import { Popup } from 'semantic-ui-react';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import WifiIcon from '@material-ui/icons/Wifi';
import SyncIcon from '@material-ui/icons/Sync';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import GroupIcon from '@material-ui/icons/Group';
import DoneIcon from '@material-ui/icons/Done';

// Local Constants
import {
    SAVED_ONLINE,
    OFFLINE_ONLY,
    UPLOAD_FAILED,
    UPDATING,
    MULTIPLE_GROUPS,
    IN_PROGRESS,
    ERROR,
    SUCCESS
} from './constants';

// Styles
import './styles.scss';

interface Props {
    status?:
        | typeof SAVED_ONLINE
        | typeof OFFLINE_ONLY
        | typeof UPLOAD_FAILED
        | typeof UPDATING
        | typeof MULTIPLE_GROUPS
        | typeof IN_PROGRESS
        | typeof ERROR
        | typeof SUCCESS;
    withText?: boolean;
    popupContent?: React.ReactElement;
    small?: boolean;
}

const StatusIcon = ({
    status,
    withText,
    popupContent,
    small
}: Props): React.ReactElement => {
    let text = 'SAVED ONLINE';
    let icon = (
        <WifiIcon
            htmlColor="#fff"
            style={{
                fontSize: 14,
                margin: 3
            }}
        />
    );

    if (status === OFFLINE_ONLY) {
        text = 'OFFLINE ONLY';
        icon = (
            <WifiOffIcon
                htmlColor="#fff"
                style={{
                    fontSize: 14,
                    margin: 3
                }}
            />
        );
    }

    if (status === UPDATING) {
        text = 'UPDATING';
        icon = (
            <SyncIcon
                htmlColor="#fff"
                style={{
                    fontSize: 16,
                    margin: 2
                }}
            />
        );
    }

    if (status === UPLOAD_FAILED) {
        text = 'UPLOAD FAILED';
        icon = (
            <PriorityHighIcon
                htmlColor="#fff"
                style={{
                    fontSize: small ? 13 : 14,
                    margin: 3
                }}
            />
        );
    }

    if (status === MULTIPLE_GROUPS) {
        text = 'MULTIPLE GROUPS';
        icon = (
            <GroupIcon
                htmlColor="#fff"
                style={{
                    fontSize: 12,
                    margin: 4
                }}
            />
        );
    }

    if (status === IN_PROGRESS) {
        text = 'IN PROGRESS';
        icon = (
            <SyncIcon
                htmlColor="#fff"
                style={{
                    fontSize: 16,
                    margin: 2
                }}
            />
        );
    }

    if (status === ERROR) {
        text = 'ERROR';
        icon = (
            <PriorityHighIcon
                htmlColor="#fff"
                style={{
                    fontSize: small ? 13 : 14,
                    margin: 3
                }}
            />
        );
    }

    if (status === SUCCESS) {
        text = 'SUCCESS';
        icon = (
            <DoneIcon
                htmlColor="#fff"
                style={{
                    fontSize: 16,
                    margin: 2
                }}
            />
        );
    }

    const content = (
        <div
            className={classNames('status-icon-content', {
                'offline-only': status === OFFLINE_ONLY,
                updating: status === UPDATING || status === IN_PROGRESS,
                'upload-failed': status === UPLOAD_FAILED || status === ERROR,
                'multiple-groups': status === MULTIPLE_GROUPS
            })}
        >
            {icon}
        </div>
    );

    if (!withText) {
        return (
            <Popup
                trigger={
                    <div
                        className={classNames('status-icon', {
                            small
                        })}
                    >
                        {content}
                    </div>
                }
                mouseEnterDelay={300}
                content={popupContent || text}
                inverted
                basic
            />
        );
    }

    return (
        <div
            className={classNames('status-icon', {
                small
            })}
        >
            {content}
            <div className="status-icon-text">{text}</div>
        </div>
    );
};

export default StatusIcon;
